import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { GIPHY_API_KEY } from '../../../config.js'
import axios from 'axios'
import './index.less'
import { Dropdown, Input } from 'antd'
import { GifsList } from 'components/GifsList'
import { GifsCarousel } from 'components/GifsCarousel'
import { DebounceInput } from 'react-debounce-input'

export const GifSearchInput = ({ selectGifCallback }) => {
  const [gifListIsVisible, setGifListVisibility] = useState(false)
  const [gifsUrl, setGifsUrl] = useState([])
  const [fetched, setFetchedGifs] = useState(false)

  const searchGifs = async (searchString = 'games') => {
    let gifsUrl = []

    let { data } = await axios.get(
      `https://api.giphy.com/v1/gifs/search?q=${searchString}&api_key=${GIPHY_API_KEY}&limit=20&lang=pt`,
    )
    data.data.forEach(gif => {
      gifsUrl = [...gifsUrl, gif.images]
    })

    setGifsUrl(gifsUrl)
    setFetchedGifs(true)
    setGifListVisibility(true)
  }

  const selectGif = gifUrl => {
    setGifListVisibility(false)
    selectGifCallback(gifUrl)
  }

  return (
    <Dropdown
      getPopupContainer={trigger => trigger.parentNode}
      overlay={
        <Fragment>
          <GifsCarousel
            selectGif={selectGif}
            gifsUrl={gifsUrl}
            fetched={fetched}
          />
          <GifsList selectGif={selectGif} gifsUrl={gifsUrl} fetched={fetched} />
        </Fragment>
      }
      trigger={['click']}
      onVisibleChange={visible => setGifListVisibility(visible)}
      visible={gifListIsVisible}
    >
      <DebounceInput
        element={Input}
        minLength={0}
        debounceTimeout={500}
        id='search-input'
        autoComplete='off'
        placeholder='Pesquise GIFs para deixar seu presente mais legal'
        onPressEnter={event => searchGifs(event.target.value)}
        onChange={event => searchGifs(event.target.value)}
        style={{ width: '100%' }}
      />
    </Dropdown>
  )
}
GifSearchInput.propTypes = {
  /** Function to be called when the user chooses the gif from the list */
  selectGifCallback: PropTypes.func.isRequired,
}
